import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
} from '@acme/api';
import {
  ApplicationFormAgentInfo,
  findAction,
  type FormAgentInfoFormData,
} from '@acme/features';
import { BreadcrumbItem, Page } from '@acme/foundation';
import { $application, applicationOpened } from '@entities/application';
import {
  $isSubmitting,
  applicationActionSucceeded,
  formAgentInfoRequested,
} from '@features/applicationActions';
import { useUnit } from 'effector-react';
import { Card } from 'flowbite-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const FormAgentInfoPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    application,
    onApplicationOpened,
    onFormAgentInfoRequested,
    isSubmitting,
  } = useUnit({
    application: $application,
    onApplicationOpened: applicationOpened,
    onFormAgentInfoRequested: formAgentInfoRequested,
    isSubmitting: $isSubmitting,
  });

  const actions = application?.actions ?? null;
  const formAction = useMemo(
    () =>
      findAction(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormAgentInfo
      ),
    [actions]
  );

  useEffect(() => {
    const unsub = applicationActionSucceeded.watch(() => {
      if (id) {
        onApplicationOpened({ id });
        navigate(`/application/${id}`);
      }
    });
    return () => unsub();
  }, [id, navigate, onApplicationOpened]);

  const handleConfirm = useCallback(
    (data: FormAgentInfoFormData) => {
      if (!formAction?.id) return;
      onFormAgentInfoRequested({ actionId: formAction.id, data });
    },
    [formAction?.id, onFormAgentInfoRequested]
  );

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Главная', onClick: () => navigate('/dashboard') },
    ...(application
      ? [
          {
            label: application.code ?? 'Заявка',
            onClick: () => navigate(`/application/${application.id}`),
          },
          { label: 'Информация об агенте' },
        ]
      : [{ label: 'Заявка не найдена' }]),
  ];

  return (
    <Page breadcrumbItems={breadcrumbItems}>
      <Card>
        <ApplicationFormAgentInfo
          inline
          isSubmitting={isSubmitting}
          onConfirm={handleConfirm}
        />
      </Card>
    </Page>
  );
};
